import { setTerm } from './helpers';

export const setAllDayAccess = setTerm('all_day_access');
